import { useState } from "react";
import BASE_URL from "../Utilities/BASE_URL";

const usePost = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postData = async (route, postData = {}, token = null) => {
    setLoading(true);
    setError(null);

    try {
      const headers = {
        "Content-Type": "application/json",
      };

      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      const response = await fetch(`${BASE_URL}${route}`, {
        method: "POST",
        headers,
        body: JSON.stringify(postData),
        credentials: "include", // Include cookies in request
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Something went wrong");
      }

      setData(result);
      setLoading(false);
      return result;
    } catch (error) {
      setError(error.message || "Something went wrong");
      setLoading(false);
      throw error;
    }
  };

  return { data, loading, error, postData };
};

export default usePost;
